import { useSyncExternalStore } from "react";

/**
 * Whether a sign-out is running. Sign-out can wait briefly for this browser's
 * instant-alert registration to be released (SIGN_OUT_DEVICE_RELEASE_BOUND_MS),
 * so the button that started it shows that it is working instead of looking
 * dead (PUX-I-1). The sign-out itself lives in lib/supabase.ts; this module
 * only holds the flag and stays free of Supabase and push code.
 */
let pending = false;
const listeners = new Set<() => void>();

export function setSignOutPending(next: boolean): void {
  if (pending === next) return;
  pending = next;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** True from the moment a sign-out starts until it settles. */
export function useSignOutPending(): boolean {
  return useSyncExternalStore(subscribe, () => pending, () => false);
}
